module.exports = __webpack_public_path__ + "static/media/location-pin-secondary.05841d2e.svg";